// react-native-datepicker -> native browser date/time input
import React from "react";
import moment from "moment";

const INPUT_TYPES = {
  date: { type: "date", format: "YYYY-MM-DD" },
  time: { type: "time", format: "HH:mm" },
  datetime: { type: "datetime-local", format: "YYYY-MM-DDTHH:mm" },
};

export default class DatePicker extends React.Component {
  static defaultProps = { mode: "date", disabled: false };

  outputFormat() {
    const { format, mode } = this.props;
    if (format) {
      return format;
    }
    return mode === "datetime"
      ? "YYYY-MM-DD HH:mm"
      : INPUT_TYPES[mode || "date"].format;
  }

  toInput(value) {
    if (!value) {
      return "";
    }
    const input = INPUT_TYPES[this.props.mode] || INPUT_TYPES.date;
    const parsed =
      value instanceof Date ? moment(value) : moment(value, this.outputFormat());
    return parsed.isValid() ? parsed.format(input.format) : "";
  }

  render() {
    const { mode, date, minDate, maxDate, disabled, style } = this.props;
    const input = INPUT_TYPES[mode] || INPUT_TYPES.date;
    const width = style && style.width ? style.width : 200;

    return (
      <input
        type={input.type}
        value={this.toInput(date)}
        min={this.toInput(minDate)}
        max={this.toInput(maxDate)}
        disabled={disabled}
        onChange={e => {
          const parsed = moment(e.target.value, input.format);
          if (parsed.isValid() && this.props.onDateChange) {
            this.props.onDateChange(
              parsed.format(this.outputFormat()),
              parsed.toDate(),
            );
          }
        }}
        style={{
          width,
          height: 40,
          fontSize: 16,
          padding: "0 8px",
          border: "1px solid #aaa",
          borderRadius: 2,
          boxSizing: "border-box",
          fontFamily: "Roboto, Arial, sans-serif",
        }}
      />
    );
  }
}
